import { extendBaseTheme } from '@chakra-ui/react';
import { foundations } from './foundations';
import { components } from './components';
const extensions = {
    components,
    ...foundations,
};
export const theme = extendBaseTheme(extensions);
